import React, { Component } from 'react'
import pt from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { getBEMClasses } from '../../util/text'
import FeedContextMenu from '../FeedContextMenu'
import TriangleUp from '../icon/TriangleUp'
import TriangleDown from '../icon/TriangleDown'

import './Item.scss'

class SectionItem extends Component {
  state = {
    isClicked: false,
    isHovered: false,
    directionLeft: false
  }

  setDropdownDirection = e => {
    const target = e.target

    const filterOffsetRight = document.querySelector('.feeds-filter').getBoundingClientRect().right
    const targetOffsetRight = target.getBoundingClientRect().right
    const realTargetOffset = Math.abs(targetOffsetRight - filterOffsetRight)
    if (realTargetOffset < 350) {
      this.setState({
        directionLeft: true
      })
    } else {
      this.setState({
        directionLeft: false
      })
    }
  }

  render() {
    let {
      exact,
      mods = [],
      text,
      to = '/',
      isScrollingMode,
      ui,
      itemClassName,
      isStatic,
      hoverParent,
      switchViewSettings,
      switchViewOptions,
      viewSettings,
      isFloatingButtonPressed,
      switchOptionsShown,
      isCollectionViewBarShown,
      type
    } = this.props
    const { isInProfile } = this.props
    const { isClicked, directionLeft } = this.state

    const segments = location.pathname.substr(1).split('/')

    const isInCards = location.pathname.includes('/cards')
    const isInCollection = location.pathname.includes('/collections')
    const isInSaved = location.pathname.includes('/saved')
    const isInHome = !!segments[1]

    return (
      <div
        className={
          `feeds-filter-item__wrap ${ui.isFeedsListExpanded ? 'feeds-filter-item__wrap--expanded' : ''} ${
            isInProfile ? 'feeds-filter-item__wrap--profile' : ''
          } ${isFloatingButtonPressed ? 'feeds-filter-item__wrap--show-context-menu' : ''}
        ${isScrollingMode ? 'feeds-filter-item__wrap--in-header' : ''}` +
          (type ? ' feeds-filter-item__wrap--' + type : '')
        }
        onMouseEnter={this.setDropdownDirection}
        onMouseLeave={() => {
          if (hoverParent) {
            hoverParent(false)
          }
        }}
        onMouseOver={() => {
          if (hoverParent) {
            hoverParent(true)
          }
        }}
      >
        <NavLink
          onClick={e => {
            if (to === false) {
              e.preventDefault()
              switchOptionsShown({ state: !isCollectionViewBarShown, item: text })

              return
            }
            if (to !== location.pathname) {
              window.scrollTo(0, 0)
              switchOptionsShown({ state: false })
            }
            if (to === location.pathname) {
              e.preventDefault()
              this.setState({ isClicked: !isClicked })
              switchOptionsShown({ state: !isCollectionViewBarShown, item: text })
            }
          }}
          key={`${to}-${text}`}
          to={to}
          className={
            getBEMClasses('feeds-filter-item', mods) +
            (isScrollingMode ? ' feeds-filter-item--scroll' : '') +
            (isClicked ? ' feeds-filter-item--clicked' : '') +
            (isScrollingMode ? ' feeds-filter-item--in-header' : '') +
            (itemClassName ? ` ${itemClassName}` : '')
          }
          activeClassName="feeds-filter-item--active"
          exact={exact}
        >
          <span className={getBEMClasses('feeds-filter-item__menu-title', mods)}>{text}</span>{' '}
          <span className="feeds-filter-item__item-arrow-spacer" />
          <span className="feeds-filter-item__item-arrow">
            {isCollectionViewBarShown ? <TriangleUp /> : <TriangleDown />}
          </span>
        </NavLink>
        {!isStatic && !mods.includes('header-scrolling') && (
          <FeedContextMenu
            switchViewOptions={switchViewOptions}
            switchViewSettings={switchViewSettings}
            isInFeedsFilter
            isInCards={isInCards}
            isInCollection={isInCollection}
            isInHome={isInHome}
            isInSaved={isInSaved}
            viewSettings={viewSettings}
            directionLeft={directionLeft}
            isFloatingButtonPressed={isFloatingButtonPressed}
          />
        )}
      </div>
    )
  }
}

SectionItem.propTypes = {
  exact: pt.bool,
  mods: pt.oneOfType([pt.string, pt.array]),
  isScrollingMode: pt.bool,
  text: pt.string,
  to: pt.oneOfType([pt.string, pt.object]),
  ui: pt.shape({
    scrollHeight: pt.number,
    isFeedsListExpanded: pt.bool
  }),
  itemClassName: pt.string,
  isStatic: pt.bool,
  hoverParent: pt.func,
  isInProfile: pt.bool,
  switchViewSettings: pt.func,
  switchViewOptions: pt.func,
  viewSettings: pt.object,
  type: pt.string,
  isFloatingButtonPressed: pt.bool,
  switchOptionsShown: pt.func,
  isCollectionViewBarShown: pt.bool
}

export default withRouter(SectionItem)
